import styles from './FooterCheckout.module.css'

const FooterCheckout = () => {
  return (
    <footer id="contacts" className={styles.footer}>
      <div className={styles.inner}></div>

      <div className={styles.bottom}>
        <div className={styles.row}>
          <a
            href="https://t.me/seaters_coffee"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.telegram}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
              <g clipPath="url(#clip0_24_88)">
                <path
                  d="M8.0321 12.3794L7.72962 16.5565C8.16239 16.5565 8.34982 16.3739 8.57459 16.1548L10.6036 14.251L14.8079 17.2738C15.5789 17.6957 16.1222 17.4736 16.3302 16.5774L19.0899 3.88154L19.0906 3.88079C19.3352 2.76171 18.6784 2.32411 17.9272 2.59864L1.70585 8.69598C0.598777 9.11788 0.615539 9.7238 1.51766 9.99833L5.6648 11.2648L15.2978 5.34697C15.7511 5.05224 16.1633 5.21531 15.8243 5.51004L8.0321 12.3794Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_24_88">
                  <rect
                    width="18.2857"
                    height="18.2857"
                    fill="white"
                    transform="translate(0.856934 0.856934)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <span className={styles.label}>
            Підтримка <span>10:00–22:00</span>
          </span>
        </div>
        <div className={styles.rightBottom}>
          <a href="/privacy-policy">Політика конфіденційності</a>
          <a href="/public-offer">Договір оферти</a>
          <a href="/delivery-payment">Умови доставки та оплати</a>
          <a href="/exchange" className={styles.madeBy}>
            Обмін та повернення
          </a>
        </div>
      </div>
    </footer>
  )
}

export default FooterCheckout
